import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Banner = ({ brandWinePic, content, onChangeMaskVisible, onChangeCurrentVideo }) => {
    const openVideo = () => {
        onChangeCurrentVideo({
            url: content.videoUrl,
            guid: content.videoGuid,
            duration: content.videoDuration,
        });
        onChangeMaskVisible(true);
    };

    return brandWinePic?.backgroundPic ? (
        <div className={styles.banner}>
            <img src={brandWinePic?.backgroundPic} className={styles.bannerBackground} />
            <img src="https://x0.ifengimg.com/ucms/2023_47/A21B5ACADA8FEEBF14AA2310BA2699213F53F3BD_size7_w141_h35.png" className={styles.bannerLogo1} />
            <img src="https://x0.ifengimg.com/ucms/2023_47/8C1046E053225D2805AF7FD7EDBA2BAF3D67AD45_size7_w148_h37.png" className={styles.bannerLogo2} />
            <Chip id="260757" type="struct" title="预告">
                <div className={styles.videoButton} onClick={openVideo}>
                    预告
                </div>
            </Chip>
        </div>
    ) : null;
};

Banner.propTypes = {
    brandWinePic: PropTypes.object,
    content: PropTypes.object,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
};

export default errorBoundary(Banner);
